import { NotificationService } from 'src/app/services/notification.service';
import { DropDownListDTO } from './../../../entity/dto/dropdownlist.component';
import { Component, ComponentFactoryResolver, ComponentRef, ElementRef, EventEmitter, OnInit, Output, ViewChild, ViewContainerRef } from '@angular/core';
import { AbstractControl, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Observable } from 'rxjs/internal/Observable';
import { FormularioService } from 'src/app/services/formulario.service';
import { GeneralService } from 'src/app/services/general.service';
import { GeneralComponent } from 'src/app/shared/general.component';
import { ActionMessage, TypeMessage } from 'src/app/entity/enum/enum-notification';
import { HttpErrorResponse } from '@angular/common/http';
import { map, startWith, take } from 'rxjs/operators';
import * as moment from 'moment';
import { Qua007PesagemItemComponent } from 'src/app/shared/qua007-pesagem-item/qua007-pesagem-item.component';

@Component({
    // tslint:disable-next-line: component-selector
    selector: 'app-qua007-card-IV',
    templateUrl: './qua007-card-IV.component.html'
})

export class Qua007CardIVComponent extends GeneralComponent implements OnInit {
    public formulario?: FormGroup;
    public filteredOptions: Observable<DropDownListDTO[]>;
    public filteredCargaTransbordoOptions: Observable<DropDownListDTO[]>;
    public listCargaTransbordo?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public listCargaTransbordoOriginal?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public readOnlyTransbordo?: boolean;


    child_unique_key: number = -1;
    public disabledBtnRemove: boolean = true;
    pesosItemReferences = Array<ComponentRef<Qua007PesagemItemComponent>>()

    @ViewChild("viewContainerRef", { read: ViewContainerRef })
    VCR: ViewContainerRef;

    @Output() mkCalc = new EventEmitter();
    @Output() mkCalcII = new EventEmitter();
    @Output() mkCalcIII = new EventEmitter();
    @Output() mkTonLaneHr = new EventEmitter();
    @Output() objFxAzulTransbordo = new EventEmitter();
    @Output() mkCalcPreBasica = new EventEmitter();
    // tslint:disable-next-line: max-line-length

    public readonly minItensOnList: number = 0;
    public readonly maxItensOnList: number = 10;
    constructor(protected formularioService: FormularioService,
        protected formBuilder: FormBuilder,
        protected notificationService: NotificationService,
        protected generalService: GeneralService,
        private CFR: ComponentFactoryResolver,
    ) {
        super('Etapa 4', false);
        if (this.isComercial || this.isBasica) {
            this.formulario = this.formBuilder.group({
                Peso_bruto: [null, [Validators.max(65000)]],
                Peso_tara: [null, [Validators.max(25000)]],
                Peso_liquido: [0, []],
                Inicio_descarga_data: [null, [Validators.minLength(8), Validators.pattern(this.regexDate)]],
                Inicio_descarga_hora: [null, [Validators.minLength(4), Validators.pattern(this.regexHour)]],
                Tempo_espera_patio: [null, []],
                Tempo_total_transporte: [null, []],
                Carga_transbordo: [null, []],
                Saida_transbordo_data: [null, []],
                Saida_transbordo_hora: [null, []],
                Reinicio_descarga_transbordo_data: [null, []],
                Reinicio_descarga_transbordo_hora: [null, []],
                Tempo_transbordo: [null, []],
                Termino_descarga_data: [null, [Validators.minLength(8), Validators.pattern(this.regexDate)]],
                Termino_descarga_hora: [null, [Validators.minLength(4), Validators.pattern(this.regexHour)]],
            });
        } else {
            this.step = 'Dados Pesagem'
            this.formulario = this.formBuilder.group({
                Peso_bruto: [null, [Validators.max(60000)]],
                Peso_tara: [null, [Validators.max(25000)]],
                Peso_liquido: [0, []],

            });
        }

        this.readOnlyTransbordo = true;
    }

    async ngOnInit(): Promise<void> {
        await this.getListCargaTransbordo();
        await this.calcPesoLiquido();
    }


    alertaData() {
        const dataAtual: any = moment(new Date());


        const dataInicioDescarga = moment(this.formulario.get('Inicio_descarga_data')?.value as string, 'DD/MM/YYYY');
        const dataTerminoDescarga = moment(this.formulario.get('Termino_descarga_data')?.value as string, 'DD/MM/YYYY');


        const diffInicioDescarga = Math.abs(dataAtual.diff(dataInicioDescarga, 'days'));
        const diffTerminoDescarga = Math.abs(dataAtual.diff(dataTerminoDescarga, 'days'));


        if (diffInicioDescarga > 7 || diffTerminoDescarga > 7) {
            this.notificationService.sendNotification('', TypeMessage.DiffDias, ActionMessage.Warning);
        }
    }
    validatePesoBrutoETara() {
        const bruto = this.formulario.get('Peso_bruto')?.value;
        const tara = this.formulario.get('Peso_tara')?.value;

        if (bruto > 65000) {
            this.formulario.get('Peso_bruto').setErrors({ invalidPesoBruto: true })
        }

        if (tara > 25000) {
            this.formulario.get('Peso_tara').setErrors({ invalidPesoTara: true })
        }

        if (bruto <= tara) {
            this.formulario.get('Peso_bruto').setErrors({ invalidPeso: true });
        }
        return true
    }

    changeCollapse(): void {
        this.collapseCard = this.collapseCard ? false : true;
    }

    hasErrorFormControl(campoFormulario?: AbstractControl): string {
        return this.formularioService.hasErrorFormControl(campoFormulario);
    }

    calcPesoLiquido(): void {
        const pesoBruto = this.formulario.get('Peso_bruto')?.value as number;
        const pesoTara = this.formulario.get('Peso_tara')?.value as number;
        //this.formulario.get('Peso_liquido').setValue((pesoBruto - pesoTara));
        // tslint:disable-next-line: max-line-length
        let resultado: number = 0;

        if (!!pesoBruto && !!pesoTara) {
            resultado = pesoBruto - pesoTara;
        }

        this.formulario.get('Peso_liquido').setValue(resultado);
        this.makeCalculationsIII();
    }

    changeCargaTransbordo($event: any): void {

        const cargaTransbordo = $event?.value || this.formulario.get('Carga_transbordo')?.value?.toUpperCase() as string;;
        // const cargaTransbordo = this.formulario.get('Carga_transbordo')?.value?.toUpperCase() as string;

        this.formulario.get('Tempo_transbordo').setValue('');
        if (!!cargaTransbordo && cargaTransbordo === 'SIM') {

            this.readOnlyTransbordo = false;
            this.formulario.get('Saida_transbordo_data').setValidators([Validators.minLength(8), Validators.required, Validators.pattern(this.regexDate)]);
            this.formulario.get('Saida_transbordo_hora').setValidators([Validators.minLength(4), Validators.required, Validators.pattern(this.regexHour)]);
            this.formulario.get('Reinicio_descarga_transbordo_data').setValidators([Validators.minLength(8), Validators.required, Validators.pattern(this.regexDate)]);
            this.formulario.get('Reinicio_descarga_transbordo_hora').setValidators([Validators.minLength(4), Validators.required, Validators.pattern(this.regexHour)]);
            this.formulario.get('Saida_transbordo_data').updateValueAndValidity();
            this.formulario.get('Saida_transbordo_hora').updateValueAndValidity();
            this.formulario.get('Reinicio_descarga_transbordo_data').updateValueAndValidity();
            this.formulario.get('Reinicio_descarga_transbordo_hora').updateValueAndValidity();
        }
        else {
            this.formulario.get('Saida_transbordo_data').reset();
            this.formulario.get('Saida_transbordo_hora').reset();
            this.formulario.get('Reinicio_descarga_transbordo_data').reset();
            this.formulario.get('Reinicio_descarga_transbordo_hora').reset();
            this.readOnlyTransbordo = true;
            this.formulario.get('Saida_transbordo_data').setValidators([]);
            this.formulario.get('Saida_transbordo_hora').setValidators([]);
            this.formulario.get('Reinicio_descarga_transbordo_data').setValidators([]);
            this.formulario.get('Reinicio_descarga_transbordo_hora').setValidators([]);
            this.formulario.get('Saida_transbordo_data').updateValueAndValidity();
            this.formulario.get('Saida_transbordo_hora').updateValueAndValidity();
            this.formulario.get('Reinicio_descarga_transbordo_data').updateValueAndValidity();
            this.formulario.get('Reinicio_descarga_transbordo_hora').updateValueAndValidity();
        }
        this.getTempoTransbordo();
    }

    private async getTempoTransbordo(): Promise<void> {
        const cargaTransbordo = this.formulario.get('Carga_transbordo')?.value?.trim()?.toUpperCase() as string;
        // tslint:disable-next-line: max-line-length
        const saidaTransbordoData: string = this.formulario.get('Saida_transbordo_data')?.value;
        const saidaTransbordoHora: string = this.formulario.get('Saida_transbordo_hora')?.value;
        const reiDescTransbordoData: string = this.formulario.get('Reinicio_descarga_transbordo_data')?.value;
        const reiDescTransbordoHora: string = this.formulario.get('Reinicio_descarga_transbordo_hora')?.value;


        if (!!cargaTransbordo && cargaTransbordo === 'SIM' && saidaTransbordoData?.length >= 8 && reiDescTransbordoData?.length >= 8 && saidaTransbordoHora?.length >= 4 && reiDescTransbordoHora?.length >= 4) {
            const reiDescTransbordo: Date = this.generalService.createDateTimeData(reiDescTransbordoData, reiDescTransbordoHora);
            const saidaTransbordo: Date = this.generalService.createDateTimeData(saidaTransbordoData, saidaTransbordoHora);
            // tslint:disable-next-line: max-line-length
            this.formulario.get('Tempo_transbordo').setValue(this.generalService.timeDiffCalc(reiDescTransbordo, saidaTransbordo));
            await this.getFormFatrData();
        } else {
            this.formulario.get('Tempo_transbordo').setValue('');
            await this.getFormFatrData();
        }
    }

    async createFilterCargaTransbordo(value: string): Promise<void> {
        if (!!value && value.length > 0) {
            if (this.listCargaTransbordoOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase())).length > 0) {
                this.listCargaTransbordo = this.listCargaTransbordoOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase()));
            } else {
                this.listCargaTransbordo = this.listCargaTransbordoOriginal;
            }
        } else {
            this.listCargaTransbordo = this.listCargaTransbordoOriginal;
        }
        // this.filteredCargaTransbordoOptions = this.formulario.get('Carga_transbordo').valueChanges
        //     .pipe(
        //         startWith(''),
        //         map(value => this.generalService._filterDropDownList(this.listCargaTransbordo, value))
        //     );
    }

    async getListCargaTransbordo(): Promise<void> {
        await this.formularioService.getListDropDownList('qua007', 'carga_transbordo').pipe(take(1)).toPromise().then((response: any) => {
            if (!!response?.data) {
                this.listCargaTransbordo = this.generalService.orderByDropDownList(response.data as DropDownListDTO[]);
                this.listCargaTransbordoOriginal = this.listCargaTransbordo;
            }
        }).catch(async (error: HttpErrorResponse) => {
            this.notificationService.showNotificationError(error, error.message);
        });
    }

    async makeCalculations(): Promise<void> {
        this.mkCalc.emit();
    }

    async makeCalculationsII(): Promise<void> {
        this.mkCalcII.emit();
    }

    async makeCalculationsIII(): Promise<void> {
        this.mkCalcIII.emit();
    }

    async tonLaneHr(): Promise<void> {
        this.mkTonLaneHr.emit();
    }

    async getFormFatrData(): Promise<void> {
        this.objFxAzulTransbordo.emit();
    }
    // PRE - BASICA

    async makeCalculationsPreBasica(): Promise<void> {
        this.mkCalcPreBasica.emit();
    }

    addItem() {
        this.disabledBtnRemove = false;

        this.createPesoItemComponent();
    }
    public async removeItem(): Promise<void> {
        if (!!this.pesosItemReferences) {
            this.pesosItemReferences[this.pesosItemReferences.length - 1].instance.remove(true);
            if (this.pesosItemReferences.filter(x => x.instance.btnExcluir == false).length == 0) {
                this.disabledBtnRemove = true
            }

        }
    }
    public createPesoItemComponent() {
        let componentFactory = this.CFR.resolveComponentFactory(Qua007PesagemItemComponent);
        let childComponentRef = this.VCR.createComponent(componentFactory);
        childComponentRef.instance.mkCalc.subscribe(val => {
            this.makeCalculationsPreBasica();
        });
        // childComponentRef.instance.loteDsDeletedEmitter.subscribe(
        //     () => {
        //         this.updateLocalAtual();
        //     });
        childComponentRef.instance.componentsReferences = this.pesosItemReferences;
        let childComponent = childComponentRef.instance;
        childComponent.unique_key = ++this.child_unique_key;
        childComponent.parentRef = this;
        this.pesosItemReferences.push(childComponentRef);
        this.makeCalculationsPreBasica();
    }

    public removePesoItemComponent(key: number, lastItem = false) {
        this.VCR.remove(lastItem ? this.VCR.length - 1 : key);
        this.pesosItemReferences = this.pesosItemReferences.filter(
            x => x.instance.unique_key !== key)
        this.pesosItemReferences.forEach((x, index) => {
            x.instance.unique_key = index
        })
        --this.child_unique_key;
    }

}
